// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"Login-module__fullWidth___1PJPn","divider":"Login-module__divider___25H3Y","loadingMask":"Login-module__loadingMask____iQ7g","column":"Login-module__column___1L_NT"};